import { render, staticRenderFns } from "./RegisterFormMoovaForm.vue?vue&type=template&id=1a72cf7d"
import script from "./RegisterFormMoovaForm.vue?vue&type=script&lang=js"
export * from "./RegisterFormMoovaForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormMoovaForm.vue?vue&type=style&index=0&id=1a72cf7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports